import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance with default config
const axiosInstance = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to requests if available
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  register: async (data) => {
    const response = await axiosInstance.post('/auth/register', data);
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
    }
    return response.data;
  },
  
  login: async (data) => {
    const response = await axiosInstance.post('/auth/login', data);
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
    }
    return response.data;
  },
  
  getMe: async () => {
    const response = await axiosInstance.get('/auth/me');
    return response.data;
  },
  
  logout: () => {
    localStorage.removeItem('token');
  }
};

// Presence API
export const presenceAPI = {
  create: async (data) => {
    const response = await axiosInstance.post('/presence/create', data);
    return response.data;
  },
  
  list: async () => {
    const response = await axiosInstance.get('/presence/list');
    return response.data.presences;
  },
  
  get: async (id) => {
    const response = await axiosInstance.get(`/presence/${id}`);
    return response.data;
  },
  
  delete: async (id) => {
    const response = await axiosInstance.delete(`/presence/${id}`);
    return response.data;
  }
};

// Conversation API
export const conversationAPI = {
  query: async (data) => {
    const response = await axiosInstance.post('/conversation/query', data);
    return response.data;
  },
  
  history: async (presenceId) => {
    const response = await axiosInstance.get(`/conversation/history/${presenceId}`);
    return response.data.conversations;
  }
};

// Dashboard API
export const dashboardAPI = {
  getMetrics: async (presenceId) => {
    const response = await axiosInstance.get(`/dashboard/metrics/${presenceId}`);
    return response.data;
  },
  
  getActivity: async (presenceId) => {
    const response = await axiosInstance.get(`/dashboard/activity/${presenceId}`);
    return response.data.activities;
  },
  
  getMemoryGraph: async (presenceId) => {
    const response = await axiosInstance.get(`/dashboard/memory-graph/${presenceId}`);
    return response.data.nodes;
  }
};

// Settings API
export const settingsAPI = {
  updateBehavior: async (presenceId, data) => {
    const response = await axiosInstance.put(`/settings/behavior/${presenceId}`, data);
    return response.data;
  },
  
  getPrivacy: async (presenceId) => {
    const response = await axiosInstance.get(`/settings/privacy/${presenceId}`);
    return response.data;
  }
};

// Logs & Traceability API
export const logsAPI = {
  query: async (data) => {
    const response = await axiosInstance.post('/logs/query', data);
    return response.data;
  },
  
  getTraceability: async (conversationId) => {
    const response = await axiosInstance.get(`/logs/traceability/${conversationId}`);
    return response.data;
  },
  
  exportLogs: async (data) => {
    const response = await axiosInstance.post('/logs/export', data);
    return response.data;
  },
  
  getStatistics: async (presenceId, days = 30) => {
    const response = await axiosInstance.get(`/logs/statistics/${presenceId}?days=${days}`);
    return response.data;
  }
};

export default axiosInstance;
